import { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
import ExcelJS from 'exceljs';
import {
    Form, Input, Row, Col, DatePicker, InputNumber,
    Button, Upload, message, Table, Popconfirm,
    Space
} from 'antd';
import { ClearOutlined, UploadOutlined } from '@ant-design/icons';
import FormPage from '../../../../../../../components/pages/FormPage';

const DefModel = {
    flight_number: null,
    flight_date: moment(),
    no_bc11: "",
    tgl_bc11: moment(),
    awbs: []
};

export default () => {
    const [form] = Form.useForm();
    const [model, setModel] = useState(DefModel);
    const [awbs, setAwbs] = useState([]);

    useEffect(() => {
        form.setFieldsValue(model);
    }, [model]);

    const handleFieldChange = (key, field, value) => {
        setAwbs(prev =>
            prev.map(item =>
                item.key === key ? { ...item, [field]: value } : item
            )
        );
    };

    const handleDelete = (key) => {
        setAwbs(prev => prev.filter(item => item.key !== key));
    };

    const handleClear = () => {
        setModel(DefModel);
        setAwbs([]);
    };

    const formatMawbNumber = (value) => {
        const digitsOnly = (value || '').replace(/[^0-9]/g, '');
        if (!digitsOnly) return '';
        if (digitsOnly.length <= 3) {
            return digitsOnly;
        }
        return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
    };

    const columns = [
        {
            title: 'MAWB Number',
            dataIndex: 'mawb_number',
            render: (_, record) => (
                <Input
                    value={record.mawb_number}
                    onChange={(e) => {
                        const formatted = formatMawbNumber(e.target.value);
                        handleFieldChange(record.key, 'mawb_number', formatted);
                    }}
                />
            )
        },
        {
            title: 'MAWB Date',
            dataIndex: 'mawb_date',
            render: (_, record) => (
                <DatePicker
                    value={record.mawb_date}
                    onChange={(date) => handleFieldChange(record.key, 'mawb_date', date)}
                    format="DD-MMM-YYYY"
                    placeholder=''
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'HAWB Number',
            dataIndex: 'hawb_number',
            render: (_, record) => (
                <Input
                    value={record.hawb_number}
                    onChange={(e) => handleFieldChange(record.key, 'hawb_number', e.target.value)}
                />
            )
        },
        {
            title: 'HAWB Date',
            dataIndex: 'hawb_date',
            render: (_, record) => (
                <DatePicker
                    value={record.hawb_date}
                    onChange={(date) => handleFieldChange(record.key, 'hawb_date', date)}
                    format="DD-MMM-YYYY"
                    style={{ width: '100%' }}
                    placeholder=''
                />
            )
        },
        {
            title: 'Pieces',
            dataIndex: 'jml_kemas',
            width: 80,
            render: (_, record) => (
                <InputNumber
                    min={1}
                    value={record.jml_kemas}
                    onChange={(val) => handleFieldChange(record.key, 'jml_kemas', val || 0)}
                    style={{ width: '100%' }}
                />
            )
        },
        {
            title: 'Weight',
            dataIndex: 'bruto',
            width: 100,
            render: (_, record) => (
                <InputNumber
                    min={0}
                    value={record.bruto}
                    onChange={(val) => handleFieldChange(record.key, 'bruto', val || 0)}
                    style={{ width: '100%' }}
                />
            )
        },

        {
            title: 'Kode Kemas',
            dataIndex: 'kode_kemas',
            width: 80,
            render: (_, record) => (
                <Input
                    value={record.kode_kemas}
                    onChange={(e) => handleFieldChange(record.key, 'kode_kemas', e.target.value.toUpperCase())}
                />
            )
        },
        {
            title: 'Consignee',
            dataIndex: 'exportir_name',
            render: (_, record) => (
                <Input
                    value={record.exportir_name}
                    onChange={(e) => handleFieldChange(record.key, 'exportir_name', e.target.value.toUpperCase())}
                />
            )
        },
        {
            title: 'No Pos BC11',
            dataIndex: 'no_pos_bc11',
            render: (_, record) => (
                <Input
                    value={record.no_pos_bc11}
                    onChange={(e) => handleFieldChange(record.key, 'no_pos_bc11', e.target.value)}
                />
            )
        },

        {
            title: 'Aksi',
            render: (_, record) => (
                <Popconfirm title="Hapus baris ini?" onConfirm={() => handleDelete(record.key)}>
                    <a>Hapus</a>
                </Popconfirm>
            )
        }
    ];

    const handleExcelUpload = async (file) => {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.onload = async (e) => {
            const buffer = e.target.result;
            await workbook.xlsx.load(buffer);
            const allSheetsData = [];

            console.log(allSheetsData)

            workbook.worksheets.forEach(sheet => {
                const sheetData = [];
                let headers = [];

                sheet.eachRow((row, rowIndex) => {
                    const values = row.values.slice(1);
                    if (rowIndex === 1) {
                        headers = values.map(h =>
                            h?.toString()
                                .trim()
                                .toLowerCase()
                                .replace(/\s+/g, '_')
                                .replace(/[^a-z0-9_]/g, '')
                        );
                    } else {
                        const rowObject = {};
                        headers.forEach((key, i) => {
                            rowObject[key] = values[i];
                        });
                        sheetData.push(rowObject);
                    }
                });

                allSheetsData.push({
                    sheetName: sheet.name,
                    rows: sheetData
                });
            });

            if (allSheetsData[0]?.rows[0]?.nomor_voyage) {
                const newModel = {
                    flight_number: allSheetsData[0]?.rows[0]?.nomor_voyage || "",
                    flight_date: allSheetsData[0]?.rows[0]?.tanggal_tiba ? moment(allSheetsData[0]?.rows[0]?.tanggal_tiba, "DD-MM-YYYY") : moment(),
                    no_bc11: allSheetsData[0]?.rows[0]?.nomor_daftar || "",
                    tgl_bc11: allSheetsData[0]?.rows[0]?.tanggal_daftar ? moment(allSheetsData[0]?.rows[0]?.tanggal_daftar, "DD-MM-YYYY") : moment()
                };

                const newAwbs = allSheetsData[2]?.rows.map((row, index) => ({
                    key: Date.now().toString() + index,
                    mawb_number: row?.nomor_bl || '',
                    mawb_date: row?.tanggal_bl ? moment(row?.tanggal_bl, "DD-MM-YYYY") : moment(),
                    hawb_number: row?.nomor_host_bl || '',
                    hawb_date: moment(row?.tanggal_host_bl) ? moment(row?.tanggal_host_bl, "DD-MM-YYYY") : moment(),
                    bruto: parseFloat(row?.berat) || 0,
                    jml_kemas: parseInt(row?.jumlah_kemasan) || 0,
                    exportir_name: row?.nama_penerima || '',
                    kode_kemas: row?.jenis_kemasan || '',
                    no_pos_bc11: row?.nomor_pos
                })) || [];

                setModel(newModel);
                setAwbs(newAwbs);
                message.success(`Berhasil upload, ${newAwbs?.length} AWB`);
                return;
            }
        };

        reader.readAsArrayBuffer(file);
        return false;
    };

    return (
        <Fragment>
            <FormPage
                url={'api/v1/import_awb/add'}
                formValid={false}
                model={model}
                layout="vertical"
                setModel={setModel}
                formSize="default"
                title={"AWB Import Excel"}
                emptyModel={DefModel}
                callbackPath={"/tps/import/awb"}
                onSaveEvent={() => {
                    const grouped = awbs.reduce((acc, item) => {
                        const key = item.mawb_number;
                        if (!acc[key]) {
                            acc[key] = {
                                mawb_number: item.mawb_number,
                                mawb_date: item.mawb_date,
                                hawb_number: item.mawb_number,
                                hawb_date: item.hawb_date,
                                bruto: 0,
                                jml_kemas: 0,
                                hawbs: [],
                            };
                        }

                        acc[key].hawbs.push({ ...item });
                        acc[key].bruto += item.bruto || 0;
                        acc[key].jml_kemas += item.jml_kemas || 0;
                        return acc;
                    }, {});

                    const formattedAwbs = Object.values(grouped).map(group => ({
                        ...group,
                        mawb_date: moment(group.mawb_date).format('YYYYMMDD'),
                        hawb_date: moment(group.hawb_date).format('YYYYMMDD'),
                        hawbs: group.hawbs.map(h => ({
                            ...h,
                            pieces: h?.jml_kemas,
                            weight: h?.bruto,
                            house_number: h?.hawb_number,
                            mawb_date: moment(h.mawb_date).format('YYYYMMDD'),
                            hawb_date: moment(h.hawb_date).format('YYYYMMDD'),
                            exportir_name: h?.exportir_name,
                            kode_kemas: h?.kode_kemas,
                            no_pos_bc11: h?.no_pos_bc11
                        })),
                    }));

                    return {
                        ...model,
                        flight_date: moment(model.flight_date).format('DD-MMM-YYYY'),
                        tgl_bc11: moment(model.tgl_bc11).format('YYYYMMDD'),
                        awbs: formattedAwbs
                    };
                }}
            >
                <Space>
                    <Upload accept=".xlsx" beforeUpload={handleExcelUpload} showUploadList={false}>
                        <Button icon={<UploadOutlined />}>Upload Excel</Button>
                    </Upload>
                </Space>
                <Row gutter={24} style={{ marginTop: 20, width: '50%' }}>
                    <Col span={11}>
                        <Form.Item label="Flight Number" name="flight_number" rules={[{ required: true, message: "Flight Number wajib di isi" }]}>
                            <Input
                                value={model.flight_number || ''}
                                autoComplete="off"
                                onChange={(e) => setModel(prev => ({ ...prev, flight_number: e.target.value.toUpperCase() }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Flight Date" name="flight_date" rules={[{ required: true }]}>
                            <DatePicker
                                value={model.flight_date}
                                onChange={(date) => setModel(prev => ({ ...prev, flight_date: date }))}
                                keyboard
                                style={{ width: '100%' }}
                                format="DD-MMM-YYYY"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={11}>
                        <Form.Item label="BC 11" name="no_bc11">
                            <Input
                                maxLength={6}
                                autoComplete="off"
                                value={model.no_bc11}
                                onChange={(e) => setModel(prev => ({ ...prev, no_bc11: e.target.value }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="TGL BC 11" name="tgl_bc11">
                            <DatePicker
                                value={model.tgl_bc11}
                                onChange={(date) => setModel(prev => ({ ...prev, tgl_bc11: date }))}
                                style={{ width: '100%' }}
                                format="DD-MMM-YYYY"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 12 }}>
                    <Button onClick={handleClear} icon={<ClearOutlined />} danger type="dashed">Clear</Button>
                </Row>
                <Form form={form} component={false} onValuesChange={(changed, all) => setModel(all)}>
                    <Table
                        bordered
                        dataSource={awbs}
                        columns={columns}
                        rowClassName="editable-row"
                        pagination={{ pageSize: 10 }}
                    />
                </Form>
            </FormPage>
        </Fragment>
    );
};